import { t } from '@lingui/macro';
import { QuoteItemStatusType, TireOfferMinimal, TireOfferV2, quoteItemStatus } from 'noddi-types';
import { NoddiChip } from 'noddi-ui-web';
import { shouldPayForOrder } from '../../pages/TireOfferStatus/utils';

function getTranslatedQuoteStatus(status: QuoteItemStatusType) {
  switch (status) {
    case quoteItemStatus.ACCEPTED_WAITING_PAYMENT:
      return t`Confirmed`;
    case quoteItemStatus.ACCEPTED_WITH_PAYMENT:
      return t`Processing`;
    case quoteItemStatus.INVENTORY_ORDERED_AT_SUPPLIERS_IN_FULL:
    case quoteItemStatus.INVENTORY_ORDERED_AT_SUPPLIERS_PARTIAL:
      return t`Tires ordered`;
    case quoteItemStatus.INVENTORY_RECEIVED_IN_FULL:
    case quoteItemStatus.INVENTORY_RECEIVED_PARTIAL:
      return t`Tires arrived`;
    case quoteItemStatus.TIRES_MOUNTED_ON_WHEELS_AT_STORAGE_FACILITY:
    case quoteItemStatus.TIRES_MOUNTED_ON_WHEELS_AT_CUSTOMER:
      return t`Tires mounted`;
    case quoteItemStatus.FULFILLED_WITH_PAYMENT:
      return t`Completed`;
    default:
      return null;
  }
}

interface TireOfferStatusChipProps {
  tireOffer: TireOfferV2 | TireOfferMinimal;
}

export const TireOfferStatusChip = ({ tireOffer }: TireOfferStatusChipProps) => {
  const orderAcceptedButShouldPay = shouldPayForOrder({
    status: tireOffer.status.status,
    paymentMethodInTireOffer: tireOffer.paymentMethod
  });
  return orderAcceptedButShouldPay ? (
    <NoddiChip variant='warning' label={t`Unpaid`} className='w-fit' />
  ) : getTranslatedQuoteStatus(tireOffer.status.status) ? (
    <div className='inline-flex size-fit shrink items-center justify-center rounded-md bg-purple/90 px-2 py-1'>
      <p className='text-white'>{getTranslatedQuoteStatus(tireOffer.status.status)}</p>
    </div>
  ) : null;
};
